var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"ma-0 pa-0 text-center",attrs:{"width":"100%"}},[_c('h2',{staticClass:"pt-2 pb-2"},[_c('strong',[_vm._v(" No existen subastas en esta categoría ")])]),_c('v-img',{staticClass:"mx-auto justify-center aling-center",attrs:{"max-height":"100%","max-width":"400px","src":"/images/barn.jpeg","alt":"emptystate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }